<template>
  <div class="container-fluid">
    <div class="page-title"><h3>Objetos prohibidos</h3></div>
    <div class="card mb-3">
      <div class="card-body">
        <div class="row g-2 align-items-end">
          <div class="col-md-4">
            <label class="form-label small text-muted mb-1">Nombre del objeto</label>
            <input v-model.trim="form.name" class="form-control" placeholder="Ej. Dinero" />
          </div>
          <div class="col-md-6">
            <label class="form-label small text-muted mb-1">Imagen</label>
            <input
              ref="imageInput"
              type="file"
              accept="image/*"
              class="form-control"
              @change="onImageSelected"
            />
          </div>
          <div class="col-md-2">
            <button
              class="btn btn-primary w-100"
              :disabled="!canSubmit"
              @click="createItem"
            >
              Agregar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <div v-if="items.length === 0" class="text-muted">No hay objetos prohibidos.</div>
        <div v-else class="table-responsive">
          <table class="table align-middle">
            <thead>
              <tr>
                <th style="width: 120px">Objeto</th>
                <th>Descripción</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in items" :key="item.id">
                <td>
                  <img
                    v-if="item.imageUrl"
                    :src="item.imageUrl"
                    :alt="item.name"
                    class="forbidden-thumb"
                  />
                  <span v-else class="text-muted small">Sin imagen</span>
                </td>
                <td>{{ item.name }}</td>
                <td class="text-end">
                  <button class="btn btn-sm btn-outline-danger" @click="removeItem(item.id)">
                    Eliminar
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import { forbiddenObjectsApi } from '@/api/forbidden-objects';

export default {
  name: 'ObjetosProhibidos',
  data() {
    return {
      items: [],
      form: { name: '', imageFile: null },
    };
  },
  computed: {
    canSubmit() {
      return Boolean(this.form.name && this.form.imageFile);
    },
  },
  mounted() {
    this.fetchItems();
  },
  methods: {
    async fetchItems() {
      const { data } = await forbiddenObjectsApi.getAll();
      this.items = data || [];
    },
    onImageSelected(event) {
      const file = event.target.files?.[0] || null;
      this.form.imageFile = file;
    },
    async createItem() {
      if (!this.canSubmit) return;
      await forbiddenObjectsApi.create(this.form.name, this.form.imageFile);
      this.form = { name: '', imageFile: null };
      if (this.$refs.imageInput) this.$refs.imageInput.value = '';
      await this.fetchItems();
    },
    async removeItem(id) {
      const c = await Swal.fire({ icon: 'warning', title: 'Eliminar', showCancelButton: true });
      if (!c.isConfirmed) return;
      await forbiddenObjectsApi.delete(id);
      await this.fetchItems();
    },
  },
};
</script>

<style scoped>
.forbidden-thumb {
  width: 72px;
  height: 72px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}
</style>
